import React, { useState } from 'react'
import './AppFormItem.less'
import { Icon } from 'antd'

export interface AppSearchInputProps {
	value?: string
	placeholder?: string
	onSearch?: (value: string) => void
	onChange?: (value: string) => void
}

export const AppSearchInput = (props: AppSearchInputProps) => {
	const [focus, setFocus] = useState(false)

	const onChange = () => {
		props.onChange && props.onChange(refInput.current.value)
		setFocus(false)
	}

	const onSearch = () => {
		props.onSearch && props.onSearch(refInput.current.value)
		props.onChange && props.onChange(refInput.current.value)
	}

	const refInput = React.createRef<HTMLInputElement>()
	return (
		<span className="app-form-item-input" style={{ borderWidth: '0px', width: '100%' }}>
			<div className={`mc-spinner ${focus ? 'mc-spinner-focus' : ''}`}>
				<div className="input input-group input-group-append">
					<div style={{ display: 'inline-table', width: '100%' }}>
						<div className="input-inner-warp">
							<input
								ref={refInput}
								className="input-inner input-inner-icon "
								placeholder={props.placeholder || ''}
								defaultValue={props.value}
								onBlur={onChange}
								onFocus={e => setFocus(true)}
								style = {{textAlign:'left'}}
							/>
						</div>
						<div className="input-icon-div" onClick={()=>onSearch()} >
							<Icon type="search" />
						</div>
					</div>
				</div>
			</div>
		</span>
	)
}



// WEBPACK FOOTER //
// ./src/components/AppFormItem/AppSearchInput.tsx